<template>
  <Knowledge :type="0" />
</template>

<script>
import Knowledge from '@/components/experimentation/knowledge.vue'
export default {
  components: { Knowledge },
}
</script>